import { Button } from "../Button/Button";
import { formatNumber } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "../Tooltip";

type Props = {
  onAddCreditsClick: () => void;
  creditBalance: number;
  showCredits: boolean;
};

export default function CreditBalanceSidebar({
  onAddCreditsClick,
  creditBalance,
  showCredits,
}: Props) {
  if (!showCredits) {
    return null;
  }

  const balanceText =
    creditBalance === 0 ? "No credits" : formatNumber(creditBalance);

  return (
    <div className="flex h-14 flex-col">
      <div className="h-px self-stretch rounded-full bg-border"></div>
      <div className="flex flex-1 items-center self-stretch">
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex flex-1 items-center justify-center">
              <img
                src="/CreditIcon.svg"
                alt=""
                className="mr-1.5 mb-[3px] h-5 w-5"
              />
              <span
                className={`font-semibold ${balanceText.length > 5 ? "text-sm" : "text-base"}`}
              >
                {balanceText}
              </span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Credit balance</p>
          </TooltipContent>
        </Tooltip>

        <div className="h-5 w-px rounded-full bg-border"></div>
        <Button
          variant="link"
          size="link"
          className="h-full flex-1 self-stretch rounded-none bg-linear-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent"
          onClick={onAddCreditsClick}
        >
          Add credits
        </Button>
      </div>
      <div className="h-px self-stretch rounded-full bg-border"></div>
    </div>
  );
}
